Object.defineProperty(exports, "__esModule", { value: true });
exports.inferTypeOrThrow = exports.resolveTypeOrThrow = void 0;
const InputFieldDecorators_1 = require("../InputFieldDecorators");
const typeResolvers_1 = require("../../../services/utils/gql/types/typeResolvers");
const parseNative_1 = require("../../../services/utils/gql/types/parseNative");
function resolveTypeOrThrow(type, target, fieldName) {
    const resolvedType = typeResolvers_1.resolveType(type, true, true);
    if (!resolvedType) {
        throw new InputFieldDecorators_1.InputFieldError(target, fieldName, `Explicit type is incorrect. Make sure to use either native graphql type or class that is registered with @Type decorator`);
    }
    return resolvedType;
}
exports.resolveTypeOrThrow = resolveTypeOrThrow;
function inferTypeOrThrow(target, fieldName) {
    const inferredType = parseNative_1.inferTypeByTarget(target.prototype, fieldName);
    if (!inferredType) {
        throw new InputFieldDecorators_1.InputFieldError(target, fieldName, `Could not infer return type and no type is explicitly configured. In case of circular dependencies make sure to force types of instead of infering them.`);
    }
    return typeResolvers_1.resolveType(inferredType, true, true);
}
exports.inferTypeOrThrow = inferTypeOrThrow;
//# sourceMappingURL=fieldType.js.map